import React, { useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { useNavigate, useParams } from "react-router-dom";
import { addNewResult } from "../../../../../redux/features/results/resultService";

const Jaya = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const { isResultCreating } = useSelector((state) => state.result.newResult);

    const [formData, setFormData] = useState({
        char: '',
        recd: '',
        next_mega_prize: '',
    });

    const [errorMessages, setErrorMessages] = useState({});
    const [disabledBtn, setBtnDisable] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidResult = () => {
        const errors = {};
        const trimmedChar = formData.char.trim();
        const trimmedDraw = formData.recd.trim();
        if (!trimmedChar) {
            errors.char = "Character is required.";
        } else if ((trimmedChar.length !== 1)) {
            errors.char = "Character contains only one letter.";
        }
        if (!trimmedDraw) {
            errors.recd = "Draw Numbers are required.";
        } else if ((trimmedDraw.length !== 4)) {
            errors.recd = "Draw must contain four numbers.";
        }
        if (!formData.next_mega_prize) {
            errors.next_mega_prize = "Next Mega Prize is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const insertNewResults = async () => {
        if (isValidResult()) {
            setBtnDisable(true);
            try {
                const data = {
                    lottery_id: id,
                    next_mega_prize: Number(formData.next_mega_prize).toLocaleString(),
                    create_jaya_result_dto: {
                        char: formData.char.toUpperCase(),
                        recd: formData.recd.trim()
                    }
                }
                const response = await dispatch(addNewResult(data)).unwrap();
                setBtnDisable(false);
                setFormData({
                    char: '',
                    recd: '',
                    next_mega_prize: ''
                });
                showToast('success', response.message);
                navigate('/admin/listing');
            }
            catch (error) {
                setBtnDisable(false);
                showToast('error', error.message);
            };
        }
    };

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Add Results</h1>
                <div className={styles.formContainer}>
                    <form
                        className={styles.coordinatorForm}
                        noValidate
                    >
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Character<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='char'
                                        name='char'
                                        value={formData.char ||''}
                                        onChange={(e) => {
                                            const value = e.target.value.toUpperCase();
                                            const isEnglishLetters = /^[A-Z]*$/.test(value);
                                            if (isEnglishLetters) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter Character'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.char && (
                                        <p className={`text-danger`}>{errorMessages.char}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Draw Numbers<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='recd'
                                        name='recd'
                                        value={formData.recd || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyNumbers = /^[0-9]*$/;
                                            if (onlyNumbers.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder='Enter Draw Numbers'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.recd && (
                                        <p className={`text-danger`}>{errorMessages.recd}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                         <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor="megaPrice" className={`form-label`}>
                                        Next Mega Prize<span className={`required-star`}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="next_mega_prize"
                                        name="next_mega_prize"
                                        value={formData.next_mega_prize}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        placeholder="Enter Next Mega Prize"
                                        className={`form-input-default`}
                                        min={0}
                                    />
                                    {errorMessages.next_mega_prize && (
                                        <p className={`text-danger`}>{errorMessages.next_mega_prize}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            className={`btn-primary`}
                            type='button'
                            disabled={disabledBtn}
                            onClick={insertNewResults}
                        >
                            {isResultCreating ? <BeatLoader color='#ffffff' /> : `Create`}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Jaya;